import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import esLocale from "i18n-iso-countries/langs/es.json";
import caLocale from "i18n-iso-countries/langs/ca.json";

countries.registerLocale(enLocale);
countries.registerLocale(esLocale);
countries.registerLocale(caLocale);

/** ISO alpha-2 codes the platform supports */
export const SUPPORTED_COUNTRY_CODES = [
  "ES",
  "FR",
  "IT",
  "DE",
  "PT",
  "UK",
  "US",
  "AR",
  "MX",
  "CO",
  "CL",
  "PE",
] as const;

/** EU subset used in organization and beneficiary forms */
export const EU_COUNTRY_CODES = ["ES", "FR", "IT", "DE", "PT"] as const;

export type CountryCode = (typeof SUPPORTED_COUNTRY_CODES)[number];

/** Resolve a country code to its localized name. Falls back to the code itself. */
export function getCountryName(code: string, locale: string): string {
  return countries.getName(code, locale) ?? code;
}

/** Build `{ value, label }` options for a set of country codes, sorted by label. */
export function getCountryOptions(
  codes: readonly string[],
  locale: string,
): { value: string; label: string }[] {
  return codes
    .map((code) => ({ value: code, label: getCountryName(code, locale) }))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
}
